import http, { createApi } from '@core/fetch'
import {} from '@util'

export default {
  // 获取数据
  // getDataApi: (body)=> http(`/p/wedding/index.php/ShopAdmin/APIMerchantFeed/list`,{body}),//动态列表
  // getCommentListApi:(body)=>http('/p/wedding/index.php/ShopAdmin/APIMerchantFeedComment/comment_list',{body}),//评论列表
  // publishApi:(body)=>http.post('/p/wedding/index.php/ShopAdmin/APIMerchantFeed/edit',{body,ignore:[null,undefined]}),//发布动态
  // deleteApi:(body)=>http.delete(`/p/wedding/index.php/ShopAdmin/APIMerchantFeed/feed?id=${body.id}`),//删除评论
  // commentApi:(body)=>http.post('/p/wedding/index.php/ShopAdmin/APIMerchantFeedComment/comment_add',{body}),//评论 回复评论
  // deleteCommentApi:(body)=>http.delete(`/p/wedding/index.php/ShopAdmin/APIMerchantFeedComment/merchant_comment?id=${body.id}`),//删除某条评论

  /**
   *改版接口
   */
  getMerchantListApi: body =>
    http('/hms/hljBusinessSearch/appApi/search/index', { body }), //本地商家/婚品搜索

  getNewMerchantListApi: body =>
    http('/p/wedding/index.php/Home/APISearchV3/list', { body }), //本地商家/婚品搜索/新商家接口

  getMarksListApi: body =>
    http('/p/wedding/index.php/Home/APIMark/category_marks_simple', { body }), //获取标签列表

  getVideoMarksListApi: body =>
    http('/p/wedding/index.php/Home/APIMark/category_marks', { body }), //获取视频标签列表

  publish_newApi: body =>
    http.post('/p/wedding/index.php/Home/APINote/create', {
      body,
      ignore: [null, undefined]
    }), //发布动态

  getData_newApi: createApi('/p/wedding/index.php/home/APINote/my_notes'), //动态列表

  delete_newApi: body => http.post('/p/wedding/Home/APINote/modify', { body }), //删除发布的动态

  getComment_newListApi: body =>
    http('/p/wedding/index.php/Home/APICommunityComment/listV2', { body }), //获取某个动态的评论列表

  comment_newApi: body =>
    http.post('/p/wedding/index.php/Home/APICommunityComment/addFunc', {
      body
    }), //评论 && 回复评论

  //评论 && 回复评论 （video类型的）
  postCommentVideo: body =>
    http.post('/p/wedding/home/APIMixComment/add', {
      body
    }),

  deleteComment_newApi: body =>
    http.post('/p/wedding/index.php/Home/APICommunityComment/deleteFunc', {
      body
    }), //删除某条评论

  //删除某条评论 - video类型
  delCommentVideo: body =>
    http.post('/p/wedding/index.php/Home/APIMixComment/delete', {
      body
    }),

  //搜索话题
  merchantDynamicList: body =>
    http('/hps/admin/note/noteTopic/searchTopic', {
      body
    }),

  //根据标签获取话题
  topicByMark: body =>
    http('/hps/admin/note/noteTopic/topicByMark', {
      body
    }),

  // 酒店宴会厅列表
  hotelHallList: body =>
    http(`/p/wedding/index.php/home/APIMerchant/hotel_hall_list`, {
      body
    }),
  // 获取话题Tags
  getDynamicTags: body =>
    http('/hps/admin/note/noteTopic/topicTabs', {
      body
    })
}
